import React, { useState, useEffect, Fragment } from "react"
import { Row, Col, Form, Button } from "react-bootstrap"
import ModalRegister from "./ModalRegister"
import Inputmask from "inputmask"
import { loginMail } from "./../../services/auth.service"
import Loader from "../shared/Loader"
import { useUser } from "../../context/UserProvider"
import {toast} from "react-toastify"

const LoginMail = ({ setShowLogin }) => {

	const [mail, setMail] = useState("")
	const [password, setPassword] = useState("")
	const [loading, setLoading] = useState(false)
	const {setUser, setUserToken} = useUser()


	useEffect(() => {
	}, [])

	const handleMailChange = () => e => {
		setMail(e.target.value)
	}

	const handlePasswordChange = () => e => {
		setPassword(e.target.value)
	}

	const handleSubmit = async e => {
		e.preventDefault()
		const dataToLogin = { username: mail, password: password }
		setLoading(true)
		const response = await loginMail(dataToLogin)
		console.log(response)
		if(response?.response === "success"){
			setUser(response.data.user)
			console.log("estoy en el ifff ", response.message)
			setUserToken(response.data.user.access_token)
			toast.info(response.message)
		}else{
			console.log("estoy en el else ", response.message)
			toast.error(response?.message || "Ha ocurrido un error al intentar iniciar sesión")
		}
		setLoading(false)
	}

	return (
		<Row>
			<Col md={{ span: 6, offset: 3 }}>
				<Form className="px-5" onSubmit={handleSubmit}>
					<Form.Group controlId="formBasicEmail">
						<Form.Label>Correo Electrónico Institucional</Form.Label>
						<Form.Control
							name="mail-login"
							type="text"
							placeholder="estudiante@alumnos.ulagos.cl"
							onChange={handleMailChange()}
							required
						/>
					</Form.Group>

					<Form.Group controlId="formBasicPassword">
						<Form.Label>Contraseña</Form.Label>
						<Form.Control type="password" onChange={handlePasswordChange()} required />
					</Form.Group>
					{loading ? (
						<Loader />
					) : (
						<Fragment>
							<Button variant="primary" size="lg" block type="submit">
								Ingresar
							</Button>
							<div className="actions">
								<span className="a-link" onClick={() => setShowLogin(false)}>
									Volver a Inicio
								</span>
							</div>
						</Fragment>
					)}
				</Form>
			</Col>
		
		</Row>
	)
}

export default LoginMail
